<template>
  <intro-template
    @start="next"
    button-label="Découvrir les règles de déclaration d'absence">
    <template v-slot:module-title>
      Déclarer une absence
    </template>
    <template v-slot:learnings-title>
      Dans ce module, vous allez apprendre...
    </template>
    <template v-slot:learnings>
      <p>Les règles de déclaration selon les types d’absence</p>
      <p>Les étapes de la procédure de déclaration sur la GTA</p>
    </template>
    <template v-slot:rules>
      <div class="rule">
        <p class="label">
          Associez
        </p>
        <p class="value">
          chaque règle de déclaration d’absence aux types d’absence correspondants
        </p>
      </div>
      <div class="rule">
        <p class="label">
          Identifiez
        </p>
        <p class="value">
          les zones de saisie dans l’interface GTA
        </p>
      </div>
    </template>
  </intro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Intro',
  mixins: [stepMixin]
}
</script>
